import chil_toefl from "./children/chil_toefl";
import chil_ielts from "./children/chil_ielts";
import chil_user from "./children/chil_user";
export default [
  {
    path: "/",
    redirect: "/index"
  },
  {
    path: "/index",
    component: () => import("@/views/index/index.vue")
  },
  {
    path: "/user",
    component: () => import("@/views/user/index.vue"),
    children: chil_user
  },
  // 托福
  {
    path: "/toefl",
    component: () => import("@/views/toefl/toefl.vue"),
    children: chil_toefl
  },
  {
    path: "/toefl/read/browse",
    component: () => import("@/views/toefl/read/browse/index.vue")
  },
  {
    path: "/toefl/read/intro",
    component: () => import("@/views/toefl/read/intro/intro.vue")
  },
  {
    //反馈页面
    path: "/toefl/read/feedback",
    component: () => import("@/views/toefl/read/feedback/index.vue")
  },
  {
    //答案解析页面
    path: "/toefl/read/practicereview",
    component: () => import("@/views/toefl/read/practicereview/index.vue")
  },
  {
    //回顾页面
    path: "/toefl/read/review",
    component: () => import("@/views/toefl/read/review/index.vue")
  },
  //托福听力的做题页面--播放听力页
  {
    path: "/toefl/listen/exercisecMusic",
    component: () =>
      import("@/views/toefl/listen/listeningExercisesToefl/exercisecMusic.vue")
  },
  //托福听力的做题页面--听力题目页
  {
    path: "/toefl/listen/exercisecTopic",
    component: () =>
      import(
        "../views/toefl/listen/listeningExercisesToefl/exercisecTopic.vue"
      )
  },
  //托福听力的回顾页面
  {
    path: "/toefl/listen/listeningReview",
    component: () =>
      import("../views/toefl/listen/listeningReview/listeningReview.vue")
  },
  // 托福听力答案页面
  {
    path: "/toefl/listen/feedback",
    component: () => import("../views/toefl/listen/feedback/index.vue")
  },
  // 雅思
  {
    path: "/ielts",
    component: () => import("@/views/ielts/ielts.vue"),
    children: chil_ielts
  },
  {
    path: "/ielts/hearing",
    component: () => import("@/views/ielts/hearing/hearing.vue")
  },
  {
    path: "/ielts/read/intro1",
    component: () => import("@/views/ielts/read/intro1/intro1.vue")
  },
  {
    path: "/ielts/newRead/intro1",
    component: () => import("@/views/ielts/newRead/intro1/intro1.vue")
  },
  // 雅思的听力的Review页面
  {
    path: "/ielts/hearingReview",
    component: () => import("@/views/ielts/listen/hearingReview/index.vue")
  },
  // 雅思的听力的批改结果页面
  {
    path: "/ielts/hearingResult",
    component: () => import("@/views/ielts/listen/resultsPage/index.vue")
  },
  {
    path: "/ielts/hearingAnswer",
    component: () =>
      import("@/views/ielts/listen/hearingAnswer/hearingAnswer.vue")
  },
  {
    path: "/ielts/hearingTask",
    component: () =>
      import("@/views/ielts/listen/hearingTask/hearingTask.vue")
  },
  {
    path: "/ielts/hearingAnswerNew",
    component: () =>
      import("@/views/ielts/listen/hearingAnswerNew/hearingAnswerNew.vue")
  },
  {
    path: "/ielts/newHearing",
    component: () =>
      import("@/views/ielts/listen/newHearing/newHearing.vue")
  },
  {
    path: "/toefl/listen/hearing",
    component: () => import("@/views/toefl/listen/hearing/hearing.vue")
  },
  //托福听力的精听页面
  {
    path: "/ielts/read/review",
    component: () => import("@/views/ielts/read/review/index.vue")
  },

  // 雅思的阅读的批改结果页面
  {
    path: "/ielts/read/correctionResult",
    component: () => import("@/views/ielts/correctionResult/index.vue")
  },
  //雅思单科模考页面
  {
    path: "/ielts/mock/singleMock",
    component: () => import("../views/ielts/mock/singleMock/singleMock.vue")
  },
  {
    path: "/ielts/mock/newSingleMock",
    component: () => import("../views/ielts/mock/singleMock/newSingleMock.vue")
  },
  // 雅思全科模考页面
  {
    path: "/ielts/mock/allMock",
    component: () => import("../views/ielts/mock/allMock/allMock.vue")
  },

  // 雅思口语做题页面
  {
    path: "/ielts/oralLanguage/practice",
    component: () => import("@/views/ielts/oralLanguage/practice")
  },
  //雅思模考欢迎页面
  {
    path: "/ielts/mock/IntroductionMock",
    component: () =>
      import("../views/ielts/mock/IntroductionMock/IntroductionMock.vue")
  },

  // 雅思口语回顾页面
  {
    path: "/ielts/oralLanguage/review",
    component: () => import("@/views/ielts/oralLanguage/review")
  },
  //个人中心,我的课程时间表
  {
    path: "/schedule",
    component: () => import("@/views/user/schedule")
  },
  // //阅读解析
  {
    path: "/ielts/read/analysis",
    component: () => import("@/views/ielts/analysis/analysis")
  },
  //听力解析
  {
    path: "/ielts/tingli",
    component: () => import("@/views/ielts/analysis/tingli")
  },
  //写作解析
  {
    path: "/ielts/xiezuo",
    component: () => import("@/views/ielts/analysis/xiezuo")
  },
  //写作解析
  {
    path: "/ielts/kkk",
    component: () => import("@/views/ielts/analysis/kkk")
  },
  //模考阅读解析
  {
    path: "/ielts/mAnalysis",
    component: () => import("@/views/ielts/modelExaminationAnalysis/mAnalysis")
  },
  //模考听力解析
  {
    path: "/ielts/mTingli",
    component: () => import("@/views/ielts/modelExaminationAnalysis/mTingli")
  },
  //写作批改列表
  {
    path: "/ielts/xieZuoList",
    component: () => import("@/views/ielts/xieZuoList/index")
  },
  //口语批改列表
  {
    path: "/ielts/kouYuList",
    component: () => import("@/views/ielts/kouYuList/index")
  },
  //口语解析
  {
    path: "/ielts/kouyu",
    component: () => import("@/views/ielts/analysis/kouyu")
  },
  //写作示例
  {
    path: "/ielts/example",
    component: () => import("@/views/ielts/example/index")
  },
  //
  {
    path: "/ielts/ieltsCourse",
    component: () => import("@/views/ielts/ieltsCourse/index")
  },
  //新练习
  {
    path: "/ielts/practice",
    component: () => import("@/views/ielts/practice/index")
  },
  // 新模考阅读
  {
    path: "/ielts/newtest",
    component: () => import("@/views/ielts/newtest/index")
  },
  {//新版解析 阅读
    path: "/ielts/newTestAnalysis",
    component: () => import("@/views/ielts/newTestAnalysis/index")
  },
    {//新版解析 听力
    path: "/ielts/newTestAnalysis1",
    component: () => import("@/views/ielts/newTestAnalysis1/index")
  },
  // 新模考 听力
  {
    path: "/ielts/newtest1",
    component: () => import("@/views/ielts/newtest1/index")
  },
  // 新模考 写作
  {
    path: "/ielts/newtest2",
    component: () => import("@/views/ielts/newtest2/index")
  },
  // 老阅读模考
  {
    path: "/ielts/oldRead",
    component: () => import("@/views/ielts/oldRead/index")
  },
  // 老听力模考
  {
    path: "/ielts/oldHearing",
    component: () => import("@/views/ielts/oldHearing/index")
  },
  // 老阅读模考
  {
    path: "/ielts/oldWriting",
    component: () => import("@/views/ielts/oldWriting/index")
  },
  // 全科模考跳板
  {
    path: "/ielts/mockExam",
    component: () => import("@/views/ielts/mockExam/index")
  },
  // 阅读解析
  {
    path: "/ielts/newAnalysis",
    component: () => import("@/views/ielts/analysis/newAnalysis")
  },
  // 听力解析
  {
    path: "/ielts/newAnalysis1",
    component: () => import("@/views/ielts/analysis/newAnalysis1")
  },
  // 写作解析
  {
    path: "/ielts/newAnalysis2",
    component: () => import("@/views/ielts/analysis/newAnalysis2")
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js